import { useTranslation } from 'react-i18next';



export const ErrorDiv = () => {
	const { t } = useTranslation('global');

	return (
		<div className="mdx-error-div">
			<p className='error-message'>{t('loadingErrorMessage')}</p>
		</div>
	);
};